import { Menu } from "antd";
import "./style.css";
import { Link, useLocation } from "react-router-dom";

const TEXT = {
  dashboard: 'Dashboard Hội Viên',
  manager_account: 'Quản lý tài khoản',
  history: 'Lịch sử',
  gamingHis: 'Lịch sử chơi',
  conversionHis: 'Lịch sử quy đổi DTC',
  playHis: 'Lịch sử lượt chơi',
  mannager_game: 'Quản lý game',
  setup_countdown: 'Bật tắt game',
  setup_condition: 'Cài đặt điều kiện',
  setup_score: 'Cài đặt điểm nhận',
  setup_gameplay: 'Cài đặt tốc độ & boom',
  setup_rule: 'Cài đặt thể lệ',
  update_turn: 'Thêm/bớt lượt chơi',
  popup_fake_user: 'Quản lý popup trúng thưởng lớn',
}

const SideBarCustom = () => {
  const auth = JSON.parse(localStorage.getItem("auth"));

  let location = useLocation();
  const currentPath = location.pathname;

  const menuItemsSuperAdmin = [
    {
      key: '/dashboard',
      label: <Link to="/dashboard">{TEXT.dashboard}</Link>,
    },
    {
      key: '/account',
      label: <Link to="/account">{TEXT.manager_account}</Link>,
    },
    {
      label: TEXT.history,
      key: 'history',
      style: { padding: "0" },
      children: [
        {
          label: <Link to="/conversionHis">{TEXT.conversionHis}</Link>,
          key: "/conversionHis",
        },
        {
          label: <Link to="/playHis">{TEXT.playHis}</Link>,
          key: "/playHis",
        },
        {
          label: <Link to="/gamingHis">{TEXT.gamingHis}</Link>,
          key: "/gamingHis",
        }
      ],
    },
    {
      label: TEXT.mannager_game,
      key: 'mannager_game',
      style: { padding: "0" },
      children: [
        {
          label: <Link to="/setup_countdown">{TEXT.setup_countdown}</Link>,
          key: "/setup_countdown",
        },
        {
          label: <Link to="/setup_condition">{TEXT.setup_condition}</Link>,
          key: "/setup_condition",
        },
        {
          label: <Link to="/setup_score">{TEXT.setup_score}</Link>,
          key: "/setup_score",
        },
        {
          label: <Link to="/setup_gameplay">{TEXT.setup_gameplay}</Link>,
          key: "/setup_gameplay",
        },
        {
          label: <Link to="/setup_rule">{TEXT.setup_rule}</Link>,
          key: "/setup_rule",
        },
        {
          label: <Link to="/update_turn">{TEXT.update_turn}</Link>,
          key: "/update_turn",
        },
        {
          label: <Link to="/popup_fake_user">{TEXT.popup_fake_user}</Link>,
          key: "/popup_fake_user",
        },
      ],
    },
  ];

  const menuItemsAdmin = [
    {
      key: '/dashboard',
      label: <Link to="/dashboard">{TEXT.dashboard}</Link>,
    },
    {
      key: '/account',
      label: <Link to="/account">{TEXT.manager_account}</Link>,
    },
    {
      label: TEXT.history,
      key: 'history',
      style: { padding: "0" },
      children: [
        {
          label: <Link to="/conversionHis">{TEXT.conversionHis}</Link>,
          key: "/conversionHis",
        },
        {
          label: <Link to="/playHis">{TEXT.playHis}</Link>,
          key: "/playHis",
        },
        {
          label: <Link to="/gamingHis">{TEXT.gamingHis}</Link>,
          key: "/gamingHis",
        }
      ],
    }
  ]

  return (
    <>
      <div className="logo font-extrabold flex text-center">Hậu Đài Game Chạm Bóng</div>
      <Menu 
        mode="inline"
        selectedKeys={[currentPath]}
        items={auth?.role === "super_admin" ? menuItemsSuperAdmin : menuItemsAdmin}
      />
    </>
  );
};

export default SideBarCustom;
